<template>
<div>
    <template v-if="onspecials.length">
        <h3 class="columnTit"><span>正在拍卖</span><a href="/preauction" target="_blank">查看更多</a></h3>
        <ul class="aucList fix flex">
            <template v-for="(item,i) in onspecials">
                <li :key="i" v-if="i<2">
                    <a :href="(item.type==1?'/special_detail/':'/meeting_detail/')+item.source_code" target="_blank">
                        <div class="imgBox">
                            <el-image style="width: 100%; height: 100%;" :src="item.cover_pic" fit="cover">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="el-image__error">
                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                </div>
                            </el-image>
                            <div v-if="item.bid_status>0&&item.bid_status!=3&&item.bid_status_name" class="liveIcon" :style="(item.bid_status==2)?'padding:0 10px 0  0;':''">
                                <lottie v-if="item.bid_status==2 " class="liveIconSty" :options="heartOptions" :height="18" :width="18"></lottie>
                                {{item.bid_status_name}}
                            </div>
                            <!--  <div class="aucStatusBox">
                                
                                <span class="aucLive" v-if="item.have_live == 1 && item.live_status == 2"><img src="../../assets/imgs/list_live.gif"> 正在直播</span>
                                <span class="aucLive aucBegin" v-if="item.have_live == 1 && (item.live_status == 1 || item.live_status == 0)">即将开播</span> -->
                            <!-- <span class="aucNum">{{item.total}}</span> 
                            </div>-->
                            <!-- <span class="bigFlag" v-if="item.isHD > 0"></span> -->
                        </div>

                        <div class="aucInfo">
                            <h4 class="tit">{{item.name}}</h4>
                            <div class="flagLabel" v-if="item.label.length">
                                <template v-for="(con,k) in item.label">
                                    <span :key="k">{{con}}</span>
                                </template>
                            </div>
                            <!-- <p><label></label>
                                <template v-for="(con,k) in item.extraInfo">
                                    <span style="color: #8C8C8C;font-size: 12px;" :key="k" v-if="con.picUrl=='listicon_lot'">{{con.text}}</span>
                                </template>

                            </p> -->
                            <p><label></label>
                                <span style="color: #8C8C8C;font-size: 12px;">{{item.auction_date}}</span>
                            </p>
                            <p style="margin-top: 0;"><label></label>
                                <span style="color: #8C8C8C;font-size: 12px;">{{item.organ_name}}&nbsp;{{item.city}}</span>
                            </p>
                        </div>
                    </a>
                </li>
            </template>
        </ul>
    </template>
    <template v-if="soonspecials.length">
        <h3 class="columnTit"><span>即将开拍</span><a href="/preauction" target="_blank">查看更多</a></h3>
        <ul class="aucList fix flex">
            <template v-for="(item,i) in soonspecials">
                <li :key="i" v-if="i<2">
                    <a :href="(item.type==1?'/special_detail/':'/meeting_detail/')+item.source_code" target="_blank">
                        <div class="imgBox">
                            <el-image style="width: 100%; height: 100%;" :src="item.cover_pic" fit="cover">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                                <div slot="error" class="el-image__error">
                                    <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                </div>
                            </el-image>
                            <div v-if="item.bid_status>0&&item.bid_status!=3&&item.bid_status_name" class="liveIcon" :style="(item.bid_status==2)?'padding:0 10px 0  0;':''">
                                <lottie v-if="item.bid_status==2 " class="liveIconSty" :options="heartOptions" :height="18" :width="18"></lottie>
                                {{item.bid_status_name}}
                            </div>
                            <!--  <div class="aucStatusBox">
                              <span class="aucLive" v-if="item.have_live == 1 && item.live_status == 2"><img src="../../assets/imgs/list_live.gif"> 正在直播</span>
                                <span class="aucLive aucBegin" v-if="item.have_live == 1 && (item.live_status == 1 || item.live_status == 0)">即将开播</span> -->
                            <!-- <span class="aucNum">{{ item.total }}</span>
                            </div> -->
                            <!-- <span class="bigFlag" v-if="item.isHD > 0"></span> -->
                        </div>

                        <div class="aucInfo">
                            <h4 class="tit">{{item.name}}</h4>
                            <div class="flagLabel" v-if="item.label.length">
                                <template v-for="(con,k) in item.label">
                                    <span :key="k">{{con}}</span>
                                </template>
                            </div>
                            <!-- <p><label></label>
                                <template v-for="(con,k) in item.extraInfo">
                                    <span style="color: #8C8C8C;font-size: 12px;" :key="k" v-if="con.picUrl=='listicon_lot'">{{con.text}}</span>
                                </template>

                            </p> -->
                            <p><label></label>
                                <span style="color: #8C8C8C;font-size: 12px;">{{item.auction_date}}</span>
                            </p>
                            <p style="margin-top: 0;"><label></label>
                                <span style="color: #8C8C8C;font-size: 12px;">{{item.organ_name}}&nbsp;{{item.city}}</span>
                            </p>
                        </div>
                    </a>
                </li>
            </template>
        </ul>
    </template>
    <template v-if="result.length">
        <h3 class="columnTit"><span>拍卖结果</span><a href="/result" target="_blank">查看更多</a></h3>
        <div class="aucResult">
            <div class="resultColTit flex">
                <span class="name">拍卖会名称</span>
                <span class="number">上拍/成交(件)</span>
                <span class="price">成交额(万)</span>
                <span class="company">拍卖公司</span>
                <span class="city">拍卖城市</span>
                <span class="time">拍卖日期</span>
            </div>
            <div class="collapseItem" v-for="(item,i) in result" :key="i" @mouseenter="hover" @mouseleave="leave">
                <div class="collapseHeader">
                    <div class="flex">
                        <span class="name">
                            <router-link target="_blank" :to="{
                                            name:'meeting_detail',
                                            parmas:{
                                                id:item.session_code
                                            }
                                        }"></router-link>
                            <a :href="'/meeting_detail/'+item.session_code" target="_blank">{{item.name}}</a>
                        </span>
                        <span class="number">

                            <i>{{item.total ? item.total.replace(new RegExp('件', 'g'), '') : '--'}}/</i>
                            <i >{{item.success_total ? item.success_total :'--'}}</i>

                        </span>
                        <span class="price">
                            <template v-if="isLogin==0">
                                <a @click="gotoLogin" href="javascript:;">登录后查看</a>
                            </template>
                            <template v-else>
                                <i class="red">{{item.total_price}}</i>
                            </template>
                        </span>

                        <a href="javascript:;" class="company" @click="gotoOrgan(item)"><i>{{item.organ_name}}</i>
                            <!-- <span class="comFlag">
                                <a style="border:0px" href="https://auction.artron.net/gongyue.php" v-if="item.IsZhongPai==1" target="_blank" class="flagText flagM" title="《中国文物艺术品拍卖企业自律公约》成员单位" >
                                        <img style="height: 17px;" src="@/assets/imgs/Frame540@2x.png" alt="" >
                                    </a>
                                    <i v-if="item.IsStandard==1" title="中国文物艺术品拍卖标准化达标企业" class="flagText flagM" >DB</i>
                                    <a href="https://auction.artron.net/help/introduce/html/introduce_brand.html" target="_blank" v-if="item.zone_name!=''" class="flagM"><img src="../../assets/imgs/zoom.png" alt="已开通官网"></a>
                             
                            </span> -->
                            <!--                                                <img :src="sessionList[0].imgUrl" alt="">-->
                        </a>

                        <span class="city">
                            <i>{{item.city ? item.city : '--'}}</i>
                        </span>
                        <span class="time">
                            <el-tooltip class="item" effect="dark" :content="item.auction_date ? item.auction_date : '--'" placement="top">
                                <i>{{item.auction_date ? item.auction_date : '--'}}</i>
                            </el-tooltip>
                        
                        </span>
                    </div>
                </div>
                <!-- <div class="sessionLink" v-if="item.specialsList.length">
                    <template v-for="(con,k) in Math.ceil(item.specialsList.length/2)">
                        <div class="fix" v-if="k<5" :key="k">
                            <template v-for="(ite,m) in item.specialsList">
                                <div class="sessionBox" :key="m" v-if="m>=(k*2) && m<(k+1)*2">
                                    <div class="sessionText">
                                        <a :href="'/special_detail/'+ite.specialCode" target="_blank" :class="{'hasLabel':ite && ite.label_list}">{{ite.name}}<template v-if="ite.total">（{{ite.total}}）</template></a>
                                    </div>

                                    <div class="flag" v-if="ite.label">
                                        <template v-for="(flag,n) in ite.label">
                                            <span :key="n" v-if="flag.name == '视频直播'" title="视频直播"><img src="../../assets/imgs/icon_videoLive.png"></span>
                                            <span :key="n" v-else-if="flag.name == '图文直播'" title="图文直播"><img src="../../assets/imgs/icon_imgLive.png"></span>
                                            <span :key="n" v-else-if="flag.name == '同步拍'" title="同步拍"><img src="../../assets/imgs/icon_tbp.png"></span>
                                            <span :key="n" v-else-if="flag.name == '限时拍'" title="限时拍"><img src="../../assets/imgs/icon_tbp.png"></span>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>

                </div> -->
            </div>
        </div>
    </template>
</div>
</template>

<script>
import lottie from '@/components/common/lottie'
const liveIcon = require('@/assets/imgs/live_icon_2.json')
export default {
    props: ['onspecials', 'soonspecials', 'result', 'isLogin'],
    name: "indexSession",
    components: {
        lottie
    },
    data() {
        return {
            heartOptions: {
                animationData: liveIcon,
                loop: true,
                autoplay: true,
            },
            activeName: '0',
            idx: {
                type: Number
            }
        }
    },
    methods: {
        gotoOrgan(item) {
            if (item.zone_name != '') {
                window.location.href = '//auction.artron.net/' + item.zone_name
            } else {
                this.$router.push({
                    name: 'org_detail',
                    params: {
                        id: item.organ_code
                    }
                })
            }
        },
        hover(e) {
            let target = e.target
            target.classList.add('active')
        },
        leave(e) {
            let target = e.target
            target.classList.remove('active')
        },
        gotoLogin() {
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        }
    }
}
</script>

<style lang="scss" scoped>
/*拍品列表*/
.aucList {
    justify-content: flex-start;
    margin-bottom: 20px;

    li {
        width: 380px;
        margin-right: 20px;

        .flagLabel {
            margin-top: 10px;

            span {
                color: #999;
                background: rgba(140, 140, 140, 0.08);
                display: inline-block;
                font-size: 12px;
                padding: 0 4px;
                border-radius: 4px;
                margin-right: 6px;
                height: 18px;
                line-height: 18px;
            }

            span:last-child {
                margin-right: 0;
            }
        }

        .imgBox {
            width: 384px;
            height: 216px;
            border-radius: 12px;
            overflow: hidden;
            position: relative;

            .liveIcon {
                position: absolute;
                top: 10px;
                right: 10px;
                z-index: 3;
                font-size: 12px;
                color: #FFFFFF;
                background: rgba(0, 0, 0, 0.2);
                padding: 4px 10px;
                border-radius: 25px 25px 25px 25px;

                .liveIconSty {
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 0.2rem;
                    background: #f6344b;
                    border-radius: 25px;
                    padding: 6px;
                }
            }

            .aucStatusBox {
                position: absolute;
                left: 10px;
                bottom: 10px;
                border-radius: 10px;
                background-color: rgba(0, 0, 0, .4);
                font-size: 0;
                height: 20px;

            }

            .aucLive {
                padding: 0 10px;
                background-color: #18BD6F;
                border-radius: 10px;
                color: #fff;
                font-size: 12px;
                display: inline-block;
                line-height: 18px;
                height: 20px;
            }

            .aucLive img {
                height: 10px;
            }

            .aucBegin {
                background-color: #000
            }

            .aucNum {
                padding: 0 10px 0 5px;
                color: #fff;
                font-size: 12px;
            }

            .bigFlag {
                position: absolute;
                background: url("../../assets/imgs/icon_list_HDpic_26@2x.png") no-repeat;
                background-size: 100% 100%;
                width: 35px;
                height: 20px;
                right: 0;
                top: 0;
            }
        }

        .aucInfo {
            .tit {
                font-weight: 600;
                font-size: 16px;
                color: #222222;
                margin-top: 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            p {
                line-height: 22px;
                font-size: 14px;
                color: #262626;
                margin-top: 10px;

                label {
                    color: #8C8C8C;
                }
            }

        }
    }

    li:last-child {
        margin-right: 0;
    }
}

/*拍卖结果*/
.aucResult {
    .resultColTit {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 14px;
    }

    .name {
        width: 228px;
        margin-right: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .number {
        width: 112px;
    }

    .price {
        width: 120px;
    }

    .collapseItem .red {
        color: #F5222D;
    }

    .company {
        width: 100px;

        img {
            height: 20px;
            margin-left: 5px;
        }
    }

    .city {
        width: 60px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .time {
        width: 130px;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .flagText {
        display: inline-block;
        width: 25px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        font-size: 12px;
        margin-left: 5px;
        margin-right: 2px;
        color: #8C8C8C
    }

    .collapseHeader {
        line-height: 22px;
        color: #262626;
        font-size: 14px;
        display: flex;
        align-items: center;
        padding: 19px 10px;
    }

    .sessionLink {
        border-top: 1px solid #D9D9D9;
        padding: 0 10px;

        .sessionBox {
            width: 49%;
            display: inline-block;
            color: rgba(0, 0, 0, .85);
            line-height: 22px;
            font-size: 14px;
            padding: 10px 0;

            .sessionText {
                width: 290px;
                display: inline-block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                line-height: 14px;
            }
        }

        .sessionBox:before {
            width: 8px;
            height: 8px;
            margin-bottom: 3px;
            background-color: #329D15;
            display: inline-block;
            content: '';
            margin-right: 8px;
            border-radius: 50%;
        }

        .flag {
            display: inline-block;

            img {
                margin-right: 8px;
            }
        }
    }

    .collapseItem {
        height: 50px;
        overflow: hidden;
    }

    .active {
        background-color: #EAF5E7;
        height: auto
    }
}
</style>
